import { useMemo } from 'react';
import { NAVIGATION_INDEX } from '../constants/navigationConstants';

/**
 * Custom hook to calculate navigation indices for different navigation types
 * Simplifies the index calculation logic for keyboard navigation
 */
export const useNavigationIndices = (isHomePageEnabled) => {
    return useMemo(() => {
        let categoryIndex = NAVIGATION_INDEX.START;
        const favouritesIndex = categoryIndex++;
        const homeIndex = isHomePageEnabled ? categoryIndex++ : NAVIGATION_INDEX.DISABLED;
        return { favouritesIndex, homeIndex, categoryStartIndex: categoryIndex };
    }, [isHomePageEnabled]);
};
